<template>
  <div
    class="flex flex-col gap-1 text-base justify-center items-center self-stretch py-6 px-4 mx-auto text-violet-600 rounded-md w-full max-w-full"
    :style="{
      backgroundColor: backgroundColor,
      fontFamily: fontFamily,
      color: textColor,
      fontWeight: boldness,
    }"
  >
    <h1
      class="text-center break-words overflow-hidden text-ellipsis max-w-full whitespace-normal"
      :style="{
        fontSize: headerFontSize ? `${headerFontSize}px` : '',
        marginBottom: headerMarginBottom,
        lineHeight: headerLineHeight,
        wordWrap: 'break-word',
        hyphens: 'auto',
        fontFamily: headerFontFamily,
      }"
    >
      {{ headlineText }}
    </h1>
    <p
      class="text-center break-words overflow-hidden text-ellipsis max-w-full whitespace-normal"
      :style="{
        lineHeight: '1.5',
        fontSize: paragraphFontSize ? `${paragraphFontSize}px` : '',
        fontFamily: headerFontFamily,
      }"
    >
      {{ paragraphText }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "DirectoryHeader",
  props: {
    boldness: {
      type: String,
      default: "",
    },
    headlineText: {
      type: String,
      default: "",
    },
    paragraphText: {
      type: String,
      default: "",
    },
    fontFamily: {
      type: String,
      default: "",
    },
    textColor: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "",
    },
    headerFontSize: {
      type: String,
      default: "",
    },
    paragraphFontSize: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const headerMarginBottom = computed(() => {
      if (!props.headerFontSize) return "16px";
      const fontSize = parseInt(props.headerFontSize);
      if (fontSize > 30) {
        return `${Math.max(fontSize * 0.4, 16)}px`;
      }
      return "16px";
    });

    const headerLineHeight = computed(() => {
      if (!props.headerFontSize) return "1.3";
      const fontSize = parseInt(props.headerFontSize);
      if (fontSize > 30) {
        return "1.2";
      }
      return "1.3";
    });

    const headerFontFamily = computed(() => {
      return props.fontFamily ? `"${props.fontFamily}"` : "inherit";
    });

    return {
      headerMarginBottom,
      headerLineHeight,
      headerFontFamily,
    };
  },
});
</script>
